import {
    ChangeDetectionStrategy,
    Component,
    DestroyRef,
    ElementRef,
    inject,
    input,
    OnInit,
    output,
    viewChildren,
    ViewEncapsulation,
} from '@angular/core';
import { featuresContent } from '@shared/features-content/features-content';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { debounceTime } from 'rxjs';
import { FeaturesItem } from '@content/features/features-type';
import { JoinClassNamesPipe } from '@shared/join/join-class-names.pipe';

@Component({
    selector: 'companyid-feature-slider',
    templateUrl: './feature-slider.component.html',
    styleUrl: './feature-slider.component.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [JoinClassNamesPipe],
})
export class FeatureSliderComponent implements OnInit {
    public currentIndex = input<number>(0);
    public featureSlide = viewChildren<string, ElementRef<HTMLDivElement>>('featureSlide', {
        read: ElementRef,
    });
    public currentIndex$ = toObservable(this.currentIndex);

    public readonly chooseFeatureTitle = output<number>();
    public readonly featuresContent: FeaturesItem[] = featuresContent;

    private readonly destroyRef = inject(DestroyRef);

    public onClick(idItem: number): void {
        this.chooseFeatureTitle.emit(idItem);
    }

    public ngOnInit(): void {
        this.currentIndex$
            .pipe(debounceTime(500), takeUntilDestroyed(this.destroyRef))
            .subscribe(() => this.scrollToViewTitle());
    }

    private scrollToViewTitle(): void {
        const item = this.featureSlide()?.[this.currentIndex()];
        const parent = item?.nativeElement.parentElement;
        const scrollTo = parent && 'scrollTo' in parent;

        if (!item || !scrollTo) {
            return;
        }

        parent.scrollTo({
            left: item.nativeElement.offsetLeft - parent.offsetWidth / 2 + item.nativeElement.offsetWidth / 2,
            behavior: 'smooth',
        });
    }
}
